import { useContext, useState } from "react";
import axios from "axios";
import { AboutusPageContext } from "../../store/AboutUsPageContext";
import styles from "./JoinUsHomePage.module.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import joinUsIcon from "../../assets/joinUsIcon.png";
import { LanguageContext } from "../LanguageContext/LanguageContext";

const marketingFrontendUrl = import.meta.env.VITE_MARKETING_FRONTEND_URL;

const JoinUsHomePage = () => {
    const { aboutusScreenDetails, loading, error } = useContext(AboutusPageContext);
    const { direction } = useContext(LanguageContext);

    const [email, setEmail] = useState("");
    const [submitStatus, setSubmitStatus] = useState("");
    const [showSuccessContent, setShowSuccessContent] = useState(false);
    const [isVisible, setIsVisible] = useState(true);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error loading data</p>;

    const aboutUsDetails60 = aboutusScreenDetails?.aboutUsDetails60 || [];
    const joinTitle = aboutUsDetails60[0]?.title || "Join our newsletter now";
    const emailPlaceholder = aboutUsDetails60[1]?.title || "Your email address...";
    const buttonText = aboutUsDetails60[2]?.title || "Send";
    const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
    const imageUrl = aboutUsDetails60[0]?.imageUrl || "";

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const submitEmail = async () => {
        if (!email) {
            toast.error("Email is required");
            return;
        }
        if (!isValidEmail(email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        try {
            const response = await axios.post(
                `${marketingBackendUrl}/maflam/create-newsletter`,
                { emailId: email }
            );

            if (response.status === 200) {
                setSubmitStatus(response.data.message);
                setShowSuccessContent(true);
                setEmail("");
            }
        } catch (error) {
            toast.error("Failed to subscribe. Please try again.");
            console.error("Error submitting email:", error);
        }
    };

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={`${styles.popupContainer} ${direction === 'rtl' ? styles.rtl : styles.ltr}`}>
            <button className={`${styles.closeButton} ${direction === 'rtl' ? styles.closeButtonRtl : styles.closeButtonLtr}`} onClick={handleClose}>X</button>
            {!showSuccessContent && (
                <div className={styles.joinUsBox}>
                    <div className={styles.flexbox}>
                        <img src={joinUsIcon} style={{ width: "40px" }} alt="" />
                        <h2 className={styles.heading}>{joinTitle}</h2>
                    </div>
                    <div className={styles.searchOption}>
                        <div className={styles.inputBox}>
                            <input
                                type="email"
                                className={styles.inputField}
                                placeholder={emailPlaceholder}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <button className={styles.button} onClick={submitEmail}>
                            {buttonText}
                        </button>
                    </div>
                    {submitStatus && (
                        <p className={styles.statusMessage}>{submitStatus}</p>
                    )}
                </div>
            )}

            {showSuccessContent && (
                <div className={styles.successContentContainer}>
                    <p style={{color:"#fff", fontSize:"1.5rem", fontWeight:"bold"}}>
                        {direction === "ltr"
                            ? "Newsletter Subscription Activated!"
                            : "تم تفعيل الاشتراك في النشرة الإخبارية!"}
                    </p>
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.popupButton}
                            onClick={() => window.location.href = '/about-us'}
                        >
                            <a href={`${marketingFrontendUrl}/R2/R3/aboutus/*`} className={styles.link}>
                                {direction === "ltr" ? "About Us" : "من نحن"}
                            </a>
                        </button>
                        <button
                            className={styles.popupButton}
                            onClick={() => window.location.href = '/courses'}
                        >
                            <a href={`${marketingFrontendUrl}/R2/R3/prc/All`} className={styles.link}>
                                {direction === "ltr" ? "Checkout Courses" : "تفقد الدورات"}
                            </a>
                        </button>
                    </div>
                </div>
            )}
            <ToastContainer />
        </div>
    );
};

export default JoinUsHomePage;
